import {DialogFooter} from '@/components/ui/dialog-atoms/DialogAtoms'
import styled, {css} from 'styled-components'

export const StyledExternalCostCardEdit = styled.form(
    ({theme: {palette, spacing}}) => css`
        width: 100%;
        border-radius: 6px;
        border: 1px solid ${palette.neutral[200]};
        padding: ${spacing * 3}px ${spacing * 3}px ${spacing * 3.5}px;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
        column-gap: ${spacing * 3}px;
        row-gap: ${spacing * 3.5}px;
        & > *:first-child {
            grid-column: span 2;
        }
        & > *:nth-child(5) {
            grid-column: span 2;
        }
        & > *:last-child {
            grid-column: span 3;
            justify-self: flex-end;
        }
    `
)

export const StyledExternalCostCard = styled.div(
    ({theme: {palette}}) => css`
        width: 100%;
        border-radius: 6px;
        border: 1px solid ${palette.neutral[200]};
    `
)

export const StyledExternalCostCardHeader = styled.div(
    ({theme: {spacing, palette}}) => css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: ${spacing * 3.5}px ${spacing * 3}px;
        background-color: ${palette.neutral[50]};
        border-radius: 6px 6px 0 0;
    `
)

export const StyledExternalCostCardBody = styled.div(
    ({theme: {spacing}}) => css`
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        column-gap: ${spacing * 2}px;
        padding: ${spacing * 3}px ${spacing * 6.5}px;
    `
)

export const StyledDeleteExternalCostContent = styled.div(
    ({theme: {spacing, typography, palette}}) => css`
        ${typography.textMd};
        color: ${palette.neutral[600]};
        & b {
            font-weight: 500;
        }
        & ul {
            list-style-type: disc;
            padding-left: ${spacing * 3}px;
        }
        & li {
            margin-left: ${spacing * 3}px;
        }
    `
)

export const StyledDeleteExternalCostFooter = styled(DialogFooter)(
    ({theme: {spacing}}) => css`
        justify-content: flex-end;
        gap: ${spacing * 2}px;
    `
)
